module.exports = __webpack_public_path__ + "static/media/sortingIcon.cbe1f146.svg";